
import emailValidator from 'common/emailValidator';


export default emailValidator;